import React from "react";
import { Route, Routes } from "react-router-dom";
import AboutPage from "pages/about";
import HomePage from "pages/home";
import ServicesPage from "pages/services";
import PortfolioPage from "pages/portfolio";

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/services" element={<ServicesPage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/portfolio" element={<PortfolioPage />} />
    </Routes>
  );
};

export default AppRoutes;
